<template>
  <div class="content-meta">
    <sc-button
      class="thumbnail-button mb-3"
      @click="handleClickSelectImageButton"
    >
      <img
        src="/static/icons/button-add-cover.svg"
        class="sc-btn-icon"
        width="22"
        height="22"
      />
      {{ imageButtonName }}
    </sc-button>
    <sc-button
      class="thumbnail-button"
      @click="handleClickSelectThumbnailButton"
    >
      <img
        src="/static/icons/button-add-cover.svg"
        class="sc-btn-icon"
        width="22"
        height="22"
      />
      {{ thumbnailButtonName }}
    </sc-button>
    <div class="setting-options">
      <ul class="meta-list">
        <li class="meta-item text-truncate" @click="handleClickSelectPdf">
          <h4>ไฟล์ PDF</h4>
          <strong>
            {{ value.fileName }}
          </strong>
        </li>
        <!-- ซ่อน feature แผนที่เนื่องจาก google qouta -->
        <!--li
          class="meta-item text-truncate"
          @click="handleClickSelectLocation"
        >
          <h4>แผนที่</h4>
          <strong>
            {{ value.locationName }}
          </strong>
        </li-->
        <li
          class="meta-item text-truncate"
          @click="handleClickSelectImageAlbum"
        >
          <h4>อัลบั้มรูป</h4>
          <strong v-show="value.voucherAlbum.length > 0">
            จำนวน {{ value.voucherAlbum.length }} รูป
          </strong>
        </li>
      </ul>
    </div>
    <image-picker-modal
      v-bind="selectImageDialog"
      @cancel="handleCancelSelectImageDialog"
      @confirm="handleConfirmSelectImageDialog"
    ></image-picker-modal>
    <image-picker-modal
      v-bind="selectThumbnailDialog"
      @cancel="handleCancelSelectThumbnailDialog"
      @confirm="handleConfirmSelectThumbnailDialog"
      @fileNotChanged="handleFileNotChangedPdfDialog"
    ></image-picker-modal>
    <pdf-picker-modal
      v-bind="selectPdfDialog"
      @cancel="handleCancelSelectPdfDialog"
      @confirm="handleConfirmSelectPdfDialog($event)"
    ></pdf-picker-modal>
    <location-picker-modal
      v-bind="selectLocationDialog"
      @cancel="handleCancelSelectLocationDialog"
      @confirm="handleConfirmSelectLocationDialog($event)"
    ></location-picker-modal>
    <album-picker-modal
      v-bind="selectImageAlbumDialog"
      @cancel="handleCancelSelectImageAlbum"
      @confirm="handleConfirmSelectImageAlbum($event)"
    ></album-picker-modal>
  </div>
</template>

<script>
import ScButton from "@/lib/components/ScButton"
import ImagePickerModal from "@/lib/components/ImagePickerModal"
import PdfPickerModal from "@/lib/components/PdfPickerModal"
import LocationPickerModal from "@/lib/components/LocationPickerModal"
import AlbumPickerModal from "@/lib/components/AlbumPickerModal"

export default {
  components: {
    ScButton,
    ImagePickerModal,
    PdfPickerModal,
    LocationPickerModal,
    AlbumPickerModal,
  },
  props: {
    value: {
      type: null,
      default: undefined,
    },
    imageUrl: {
      type: null,
      default: undefined,
    },
    thumbnail: {
      type: null,
      default: undefined,
    },
  },
  data() {
    return {
      isShowSelectImageDialog: false,
      isShowSelectThumbnailDialog: false,
      isShowSelectPdfDialog: false,
      isShowSelectLocation: false,
      isShowSelectImageAlbum: false,
    }
  },
  computed: {
    selectImageDialog() {
      return {
        isShow: this.isShowSelectImageDialog,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูปปก Voucher",
        width: 375,
        height: 160,
        recommendWidth: 1125,
        recommendHeight: 480,
        thumbnailFile: this.value.imageFile,
        thumbnailUrl: this.imageUrl,
      }
    },
    selectThumbnailDialog() {
      return {
        isShow: this.isShowSelectThumbnailDialog,
        isLoading: false,
        canEdit: true,
        title: "เลือกรูป Thumbnail Voucher",
        width: 300,
        height: 200,
        recommendWidth: 1200,
        recommendHeight: 800,
        thumbnailFile: this.value.thumbnailFile,
        thumbnailUrl: this.thumbnail,
      }
    },
    selectPdfDialog() {
      return {
        isShow: this.isShowSelectPdfDialog,
        title: "เลือก PDF",
        isLoading: false,
        fileName: this.value.fileName,
      }
    },
    selectLocationDialog() {
      return {
        isShow: this.isShowSelectLocation,
        title: "แผนที่",
        isLoading: false,
        locationName: this.value.locationName,
        latitude: this.value.latitude,
        longitude: this.value.longitude,
        canEdit: true,
      }
    },
    selectImageAlbumDialog() {
      return {
        isShow: this.isShowSelectImageAlbum,
        title: "Voucher Album",
        album: this.value.voucherAlbum,
        canEdit: true,
      }
    },
    imageButtonName() {
      return !this.imageUrl ? "อัพโหลดรูปปก" : "แก้ไขรูปปก"
    },
    thumbnailButtonName() {
      return !this.thumbnail ? "อัพโหลดรูป thumbnail" : "แก้ไขรูป thumbnail"
    },
  },
  methods: {
    handleClickSelectImageButton() {
      this.isShowSelectImageDialog = true
    },
    handleCancelSelectImageDialog() {
      this.isShowSelectImageDialog = false
    },
    handleConfirmSelectImageDialog(file) {
      this.$emit("selectedImage", { imageFile: file })
      this.isShowSelectImageDialog = false
    },
    handleClickSelectThumbnailButton() {
      this.isShowSelectThumbnailDialog = true
    },
    handleCancelSelectThumbnailDialog() {
      this.isShowSelectThumbnailDialog = false
    },
    handleConfirmSelectThumbnailDialog(file) {
      this.$emit("selectedThumbnail", { thumbnailFile: file })
      this.isShowSelectThumbnailDialog = false
    },
    handleClickSelectPdf() {
      this.isShowSelectPdfDialog = true
    },
    handleCancelSelectPdfDialog() {
      this.isShowSelectPdfDialog = false
    },
    handleConfirmSelectPdfDialog(pdfFile) {
      this.$emit("selectedPdf", pdfFile)
      this.isShowSelectPdfDialog = false
    },
    handleClickSelectLocation() {
      this.isShowSelectLocation = true
    },
    handleCancelSelectLocationDialog() {
      this.isShowSelectLocation = false
    },
    handleConfirmSelectLocationDialog(location) {
      this.$emit("selectedLocation", location)
      this.isShowSelectLocation = false
    },
    handleClickSelectImageAlbum() {
      this.isShowSelectImageAlbum = true
    },
    handleCancelSelectImageAlbum() {
      this.isShowSelectImageAlbum = false
    },
    handleConfirmSelectImageAlbum(imageFiles) {
      this.$emit("selectedImageAlbum", imageFiles)
      this.isShowSelectImageAlbum = false
    },
    handleFileNotChangedPdfDialog() {
      this.isShowSelectThumbnailDialog = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";

.thumbnail-button {
  display: block;
  width: 100%;
}

.setting-options {
  .meta-list {
    list-style: none;
    padding: 0;
    margin: 24px 0 0;
    border-top: 1px solid #e0e0e0;
  }
  .meta-item {
    padding: 16px 0;
    border-bottom: 1px solid #e0e0e0;

    &:hover {
      cursor: pointer;
    }
    &::before {
      content: "";
      position: absolute;
      right: 15px;
      width: 22px;
      height: 22px;
      background-image: url("/static/icons/article-meta-icon-plus.svg");
    }
    &.edit {
      &::before {
        background-image: url("/static/icons/article-meta-icon-pencil.svg");
      }
    }
    h4 {
      font-size: 16px;
      font-weight: bold;
      line-height: 1.38;
      letter-spacing: -0.1px;
      color: $black;
      margin: 0;
    }
    strong {
      font-size: 14px;
      line-height: 1.21;
      letter-spacing: -0.1px;
      color: $orange;
    }
  }
}
</style>
